
import { useAuth } from '../composables/useAuth';
/**
 * Make sure reAuthenticate finishes before we begin rendering.
 */
export default defineNuxtPlugin(async () => {
  const auth = useAuth();
  await auth.reAuthenticate();

  const msAuth = useMSAuth()
  await msAuth.initialize()
})
